import React, { createContext, useState, useEffect } from 'react';

// Crear el contexto para el idioma / Create Language Context
export const LanguageContext = createContext();

// Diccionario de traducción / Translation dictionary
export const translations = {
  en: {
    // Títulos de páginas / Page Titles
    home: "Home",
    about: "About",
    experience: "Experience",
    educationSkills: "Education & Skills",
    projects: "Projects",
    latest: "Latest",
    download: "Download",
    viewCertificate: "View certificate",
    readMore: "Read more",

    // Menú de navegación / Navigation Menu
    navHome: "Home",
    navAbout: "About",
    navExperience: "Experience",
    navSkills: "Education & Skills",
    navProjects: "Projects",
    navBlog: "Blog & Demos",

    // Blog & Presentation
    blogTitle: "cat blog.md",
    blogSubtitle: "Articles, technical notes, and dynamic presentation decks.",
    modeArticle: "Article View",
    modePresentation: "Presentation Mode",
    slideCounter: "Slide",
    ofWord: "of",
    prevSlide: "Previous",
    nextSlide: "Next",
    toggleNotes: "Speaker Notes",
    fullScreen: "Fullscreen",
    exitPresentation: "Exit Presentation",

    // Sidebar
    role: "Computer Civil Engineer",
    roleAWS: "AWS Certified Solutions Architect Professional",
    roleDev: "Software Developer",
    roleMobile: "Mobile Developer",
    roleArch: "Software Architect",
    roleAgile: "Agile Project Management",

    // Categorías de Skills / Skill Categories
    catDev: "Development",
    catCloud: "Cloud & DevOps",
    catAiMgmt: "AI & Management",

    // Niveles de Skills / Skill Levels
    lvlExpert: "Expert",
    lvlAdvanced: "Advanced",
    lvlIntermediate: "Intermediate",

    // Nombres de Skills / Skill Names
    skillBackend: "Backend Development",
    skillFrontend: "Frontend Development",
    skillMobile: "Mobile Development",
    skillLinux: "Linux Environments",
    skillAwsAgent: "AWS Agent Development",
    skillScrum: "Scrum - Agile methodologies",
    skillTeamLead: "Team Leadership",

    // Página About / About Page
    aboutTitle: "About Me",
    aboutP1: "Graduated from the University of Santiago de Chile with a solid experience in software solutions development.",
    aboutP2: "Specialized in web, mobile development, and cloud architecture. I enjoy tackling technological challenges and making the most of the latest industry trends.",
    aboutP3: "Throughout my career, I have achieved successful results by working in highly collaborative teams, where my systemic approach and adaptability have been fundamental in overcoming obstacles and achieving remarkable outcomes.",

    // Experiencia e Historial / Experience & History
    expTitle: "cat experience.md",
    eduTitle: "cat education.md",
    skillsTitle: "cat skills.md",
    projectsTitle: "cat projects.md",

    // Tareas / Tasks (Experience / Education)
    dateActually: "Jun. 2024 - Actually",
    dateGaragelabs1: "Feb, 2022 - Jun. 2024",
    dateGaragelabs2: "Jan. 2018 - Feb. 2022",
    dateOferus: "March 2017 - Jan. 2018",
    dateCitiaps: "March 2016 - March 2017",
    dateUsach: "March 2016 - Jan. 2017",
    usachDate: "2010 - 2016",

    roleSeniorDevEx: "Senior Software Engineer DevEX",
    roleSeniorDevOps: "Senior Software Engineer DevOps",
    roleCto: "CTO",
    roleProdLeader: "Product Technical Leader",
    roleSoftEng: "Software Engineer",
    roleResAssistant: "Research Assistant",
    roleAsstProf: "Assistant Professor",
    roleUsach: "Computer Civil Engineer",

    awsCertPro26: "Jan 2026 · Expiration: Jan. 2029",
    awsCertPro22: "Nov 2022 · Expiration: Nov. 2025",
    awsCertAssoc21: "Nov 2021 · Expiration: Nov. 2025",

    // Descripciones de proyectos
    oiDesc: "I participated in the development of another developer's legacy platform. I migrated the entire platform to AWS to make it more scalable and support the projected new user loads. I applied React to some parts of the frontend to better manage it at the development level and provide a better user experience. Currently, we are progressing with new functionalities and integrating new payment methods.",
    mcmDesc: "This client also had legacy software in Visual Basic 6, hosted on an on-premise server and connected to an MS SQL Server database. Here, an inventory was made of the functionalities that would be re-implemented in a new web platform, now developed with Ruby on Rails, and supported on a highly scalable AWS platform. This new system connects to the same database. Currently, we are finishing migrating the most important functionalities, and subsequently, the platform will connect via REST API to Defontana.",
    maDesc: "It is a portal for lawyers where client tickets are managed. We integrated HubSpot to track the tickets, and developed artificial intelligence tools for ticket management on this legacy system.",
    epgDesc: "I developed the booking system for the pet hotel, allowing users to select the number of days and add extra services. For administrators, it maps the pet's journey through the hotel, finding the best room distribution to optimize occupancy."
  },
  es: {
    // Títulos de páginas / Page Titles
    home: "Inicio",
    about: "Sobre Mí",
    experience: "Experiencia",
    educationSkills: "Educación y Habilidades",
    projects: "Proyectos",
    latest: "Actual",
    download: "Descargar",
    viewCertificate: "Ver certificado",
    readMore: "Leer más",
 
    // Menú de navegación / Navigation Menu
    navHome: "Inicio",
    navAbout: "Acerca de",
    navExperience: "Experiencia",
    navSkills: "Educación y Habilidades",
    navProjects: "Proyectos",
    navBlog: "Blog y Demos",

    // Blog & Presentaciones
    blogTitle: "cat blog.md",
    blogSubtitle: "Artículos, notas técnicas y presentaciones dinámicas e interactivas.",
    modeArticle: "Modo Lectura",
    modePresentation: "Modo Presentación",
    slideCounter: "Diapositiva",
    ofWord: "de",
    prevSlide: "Anterior",
    nextSlide: "Siguiente",
    toggleNotes: "Notas del Orador",
    fullScreen: "Pantalla Completa",
    exitPresentation: "Salir de Presentación",
 
    // Sidebar
    role: "Ingeniero Civil en Informática",
    roleAWS: "AWS Certified Solutions Architect Professional",
    roleDev: "Desarrollador de Software",
    roleMobile: "Desarrollador Móvil",
    roleArch: "Arquitecto de Software",
    roleAgile: "Gestión de Proyectos Ágiles",
 
    // Categorías de Skills / Skill Categories
    catDev: "Desarrollo",
    catCloud: "Nube y DevOps",
    catAiMgmt: "IA y Gestión",
 
    // Niveles de Skills / Skill Levels
    lvlExpert: "Experto",
    lvlAdvanced: "Avanzado",
    lvlIntermediate: "Intermedio",
 
    // Nombres de Skills / Skill Names
    skillBackend: "Desarrollo Backend",
    skillFrontend: "Desarrollo Frontend",
    skillMobile: "Desarrollo Móvil",
    skillLinux: "Entornos Linux",
    skillAwsAgent: "Desarrollo de Agentes AWS",
    skillScrum: "Scrum - Metodologías Ágiles",
    skillTeamLead: "Liderazgo de Equipos",
 
    // Página About / About Page
    aboutTitle: "Sobre Mí",
    aboutP1: "Graduado de la Universidad de Santiago de Chile con una sólida experiencia en el desarrollo de soluciones de software.",
    aboutP2: "Especializado en desarrollo web, móvil y arquitectura cloud. Disfruto enfrentar desafíos tecnológicos y aprovechar al máximo las últimas tendencias de la industria.",
    aboutP3: "A lo largo de mi carrera, he logrado resultados exitosos trabajando en equipos altamente colaborativos, donde mi enfoque sistémico y adaptabilidad han sido fundamentales para superar obstáculos y alcanzar resultados notables.",
 
    // Experiencia e Historial / Experience & History
    expTitle: "cat experience.md",
    eduTitle: "cat education.md",
    skillsTitle: "cat skills.md",
    projectsTitle: "cat projects.md",
 
    // Tareas / Tasks (Experience / Education)
    dateActually: "Jun. 2024 - Actualidad",
    dateGaragelabs1: "Feb. 2022 - Jun. 2024",
    dateGaragelabs2: "Ene. 2018 - Feb. 2022",
    dateOferus: "Marzo 2017 - Ene. 2018",
    dateCitiaps: "Marzo 2016 - Marzo 2017",
    dateUsach: "Marzo 2016 - Ene. 2017",
    usachDate: "2010 - 2016",
 
    roleSeniorDevEx: "Ingeniero de Software Senior DevEX",
    roleSeniorDevOps: "Ingeniero de Software Senior DevOps",
    roleCto: "CTO",
    roleProdLeader: "Líder Técnico de Producto",
    roleSoftEng: "Ingeniero de Software",
    roleResAssistant: "Asistente de Investigación",
    roleAsstProf: "Profesor Asistente",
    roleUsach: "Ingeniero Civil en Informática",
 
    awsCertPro26: "Ene 2026 · Expiración: Ene. 2029",
    awsCertPro22: "Nov 2022 · Expiración: Nov. 2025",
    awsCertAssoc21: "Nov 2021 · Expiración: Nov. 2025",
 
    // Descripciones de proyectos
    oiDesc: "Participé en el desarrollo de la plataforma legada de otro desarrollador. Migré toda la plataforma a AWS para hacerla más escalable y soportar las nuevas cargas de usuarios proyectadas. Apliqué React en algunas partes del frontend para gestionarlo mejor a nivel de desarrollo y brindar una mejor experiencia de usuario. Actualmente, estamos progresando con nuevas funcionalidades e integrando nuevos métodos de pago.",
    mcmDesc: "Este cliente también tenía software legado en Visual Basic 6, alojado en un servidor local y conectado a una base de datos MS SQL Server. Aquí se realizó un inventario de las funcionalidades a reimplementar en una nueva plataforma web, desarrollada ahora con Ruby on Rails y soportada sobre una plataforma AWS altamente escalable. Este nuevo sistema se conecta a la misma base de datos. Actualmente estamos terminando de migrar las funcionalidades más importantes y, posteriormente, la plataforma se conectará mediante API REST a Defontana.",
    maDesc: "Es un portal para abogados donde se gestionan los tickets de clientes. Se trata de un desarrollo sobre un software legado en el que integramos HubSpot para el seguimiento de tickets, además del desarrollo de herramientas de inteligencia artificial para su gestión.",
    epgDesc: "Desarrollé el sistema de agendamiento para el hotel de mascotas, permitiendo seleccionar la cantidad de días y contratar servicios adicionales. Para los administradores, el sistema traza la ruta de la mascota en el hotel, buscando la mejor distribución de habitaciones para optimizar su uso."
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  // Cargar el idioma preferido al iniciar en el cliente / Load preferred language on client mount
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedLang = localStorage.getItem('user_lang');
      if (savedLang && (savedLang === 'en' || savedLang === 'es')) {
        setLanguage(savedLang);
      }
    }
  }, []);

  // Función para cambiar de idioma / Function to change language
  const changeLanguage = (newLang) => {
    if (newLang === 'en' || newLang === 'es') {
      setLanguage(newLang);
      if (typeof window !== 'undefined') {
        localStorage.setItem('user_lang', newLang);
      }
    }
  };

  // Función de traducción simple / Simple translate function
  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
